var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.addLink)?_c('router-link',{staticClass:"btn add-btn",attrs:{"to":_vm.addLink}},[_c('i',{staticClass:"fas fa-plus"})]):_vm._e(),(_vm.addActionRole)?_c('button',{staticClass:"btn add-btn",on:{"click":function($event){return _vm.$emit('addAction')}}},[_c('i',{staticClass:"fas fa-plus"})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }